import { ImageGalleriesImageContent } from 'components/minute/sidebar/MarkerSidebar/shared/ImageGalleriesSubsection/ImageGalleriesImageContent';
import { ImageGalleriesSymbolContent } from 'components/minute/sidebar/MarkerSidebar/shared/ImageGalleriesSubsection/ImageGalleriesSymbolContent';
import { OptionRowComponentSwitch } from 'components/minute/sidebar/shared/OptionRowComponentSwitch';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

type OnSelectedCallbackData =
    | { type: 'symbol'; imageUrl: string; color: string }
    | { type: 'image'; imageUrl: string };

interface Props {
    className?: string;
    marker: IIconV2WorldMarker | IImageV2WorldMarker;
    galleryType: 'icon' | 'image';
    order: ('icon' | 'image')[];
    allowEmpty?: boolean;
    onSelected?: (data: OnSelectedCallbackData) => void;
}

export const ImageGalleriesSubsection = (props: Props): JSX.Element => {
    const options = {
        icon: {
            menuItem: { text: Localization.SYMBOL },
            element: (
                <ImageGalleriesSymbolContent
                    marker={props.marker}
                    allowEmpty={props.allowEmpty}
                    onSelected={({ imageUrl, color }) => {
                        console.log('callback: icon');
                        props.onSelected?.({ type: 'symbol', imageUrl, color });
                    }}
                />
            )
        },
        image: {
            menuItem: { text: Localization.IMAGE },
            element: (
                <ImageGalleriesImageContent
                    selectedImageUrl={props.marker.elementData.generatedImageUrl ?? null}
                    galleryType={props.galleryType}
                    onSelected={(imageUrl) => {
                        console.log('callback: image');
                        props.onSelected?.({ type: 'image', imageUrl });
                    }}
                />
            )
        }
    };

    const orderedOptions = props.order.map((value) => options[value]);

    function getSelectedIndex() {
        const markerData = props.marker.elementData;
        if (markerData.generatedIconUrl) {
            return props.order.findIndex((e) => e === 'icon');
        }
        if (markerData.generatedImageUrl) {
            return props.order.findIndex((e) => e === 'image');
        }
        return 0;
    }

    return (
        <S_IconMarkerStyleIconSubsection className={props.className}>
            <SidebarContent withTopPadding>
                <OptionRowComponentSwitch
                    initialSelectedIndex={getSelectedIndex()}
                    options={orderedOptions}
                />
            </SidebarContent>
        </S_IconMarkerStyleIconSubsection>
    );
};

const S_IconMarkerStyleIconSubsection = styled.div``;
